import { CommonFunctions } from "../static/common-functions";
import { GeographyInfoBus } from "./GeographyInfoBus";
import { CommonValues } from "../static/CommonValues";
import { BaseInvBus } from "./BaseInvBus";
import { DateFunctions } from "../static/date-functions";

export class QuoteBus extends BaseInvBus
{
    CID(): any {
        return this.quoteId;
    }
    constructor(data: QuoteBus = null) {
        super(data);
    }
    initialize(data: QuoteBus) {
        super.initialize(data);
        try {
            this.quoteDate = CommonFunctions.getDate(data.quoteDate);
            this.followUpDate = CommonFunctions.getDate(data.followUpDate);
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }

    setFromForm(data: QuoteBus) {
        super.setFromForm(data);

        //isEquipmentWithInstall is ONLY applicable to "Equipment Sales" Class
        if (this.accountClassId !== CommonValues.Quote_Class_Equipment_Sales) {
            this.isEquipmentWithInstall = null;
        }
//        this.billingGeographyInfo = null;
//        this.shippingGeographyInfo = null;
        this.isTemplate = this.isTemplate === null ? false : this.isTemplate;
        //let dateNow = CommonFunctions.getDateNow();
        //if (this.hasId) {
        //    this.updateDt = dateNow;
        //    this.insertDt = data.insertDt;
        //    this.insertUserId = data.insertUserId;
        //}
        //else {
        //    this.insertDt = dateNow;
        //    this.insertUserId = data.insertUserId;
        //}
        if (this.printWithTerms == null) {
            this.printWithTerms = true
        }
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
        this.quoteDate = date;
        this.quoteStatusId = CommonValues.Quote_Pending;
        this.accountClassId = CommonValues.AccountClass_ReferService;
        this.salespersonId = personId;
        this.insertDt = date;
        this.updateDt = date;
        this.insertUserId = userId;
        if (CommonFunctions.hasValue(other) && other == true) {
            this.accountClassId = null;
        }
    }
    isValid(): boolean {
        return true;
    }
    setBeforeSave() {
        super.setBeforeSave();
        this.quoteDate = DateFunctions.getDateWithUTCOffset(this.quoteDate);
        if (this.isAdded) { this.quoteDate = DateFunctions.getDateNowWithUTCOffset(); }
        if (DateFunctions.isValidDate(this.followUpDate)) {
            this.followUpDate = DateFunctions.getDateTimeWithUTCOffset(this.followUpDate);
        }
    }
  quoteId: any;
  quoteStatusId: any;
  salespersonId: any;
  isTemplate: boolean;
  billingGeographyId: any;
  shippingGeographyId: any;
  dispatchId: any;
  invoiceId: any;
  quoteDate: Date;
  followUpDate: Date;
  quoteNumber: string;
  ponumber: string;
  quoteDesc: string;
  wonumber: string;
  scopeText: string;
  termText: string;
  notIncludedText: string;
  warrantyText: string;
    extendedWarrantyCost: number;
    extendedWarrantyYears: number;
    overrideContactName: string;
    printWithTerms: boolean;
    changeReqInfo: string;
    isPassThrough: boolean;
    isNewConstruction: boolean;
    shippingGeographyInfo: GeographyInfoBus;
    billingGeographyInfo: GeographyInfoBus;
    disableScopeText: boolean;
    disableTermText: boolean;
    disableNotIncludedText: boolean;
    disableWarrantyText: boolean;
    bidSheetNumber: string;
    isPotentialCustomer: boolean;
    divisionId: any;
    isEquipmentWithInstall?: boolean;
    relatedJobTypeId: any;

//    unlinkQuote: boolean;
}
